import { and, not, or, Roles } from '@/js/libs/use-auth';

// Self-booking users who pay by invoice see their own company's invoices; the
// backend scopes the list per company.
export const INVOICING_PAGE_ROLES = or(Roles.ADMIN, Roles.OPS_CHECKS, and(Roles.YALEO_SELF_BOOKING, not(Roles.CREDIT_CARD_PAYMENT_ONLY)));

// Charging, state changes and filtering by company stay with platform admins
// and ops checks; everyone else on the Invoicing page only downloads.
export const INVOICE_MANAGEMENT_ROLES = or(Roles.ADMIN, Roles.OPS_CHECKS);
